import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ContentWrapper from "../ContentWrapper";
import markdown from "../../lib/remark";
import Block from "../Block";
import Column from "../Column";
import Vimeo from '@u-wave/react-vimeo';

const propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        title: PropTypes.string
    }),
    video: PropTypes.shape({
        providerUid: PropTypes.string,
        url: PropTypes.string,
    }),
    text: PropTypes.string,
    className: PropTypes.string,
    flipTextAndImage: PropTypes.bool,
    hideImageOnMobile: PropTypes.bool
};

const defaultProps = {
    text: "",
    className: "",
    flipTextAndImage: false,
    hideImageOnMobile: false,
    image: {url: '', alt: '', title: ''},
    video: {providerUid: '', url: ''}
};

export default function ImageAndText({
    image,
    video,
    text,
    className,
    flipTextAndImage,
    hideImageOnMobile,
    smallText,
    title
}) {
    const visual = {
        image: classnames({
            "w-full  max-w-full": true
        }),
        wrapper: classnames({
            "hidden md:block": hideImageOnMobile
        })
    };

    return (
        <ContentWrapper className={className}>
            {title && (
                <Block>
                    <Column column="w-full">
                        <h2 className="text-6xl  font-header text-sky  text-concord-dark-green">
                            {title}
                        </h2>
                    </Column>
                </Block>
            )}
            <Block className="mt-5" reversed={flipTextAndImage}>
                <Column>
                    <div
                        className="cms-content"
                        dangerouslySetInnerHTML={markdown(text)}
                    />

                    {smallText && (
                        <div className="cms-content--block-info  text-concord-grey  small-text">
                            <div
                                dangerouslySetInnerHTML={markdown(smallText)}
                            />
                        </div>
                    )}
                </Column>

                {image && null === video && (
                    <Column className={visual.wrapper}>
                        <img
                            alt={image.alt}
                            title={image.title}
                            src={`${image.url}?w=600&auto=compress,format`}
                            className={visual.image}
                        />
                    </Column>
                )}

                {null !== video && (
                    <Column className={visual.wrapper}>
                        <Vimeo
                            className="vimeo-embed"
                            video={video.providerUid}
                            onReady={video => {
                                video.enableTextTrack('en', 'captions')
                            }}
                        />
                    </Column>
                )}
            </Block>
        </ContentWrapper>
    );
}

ImageAndText.propTypes = propTypes;
ImageAndText.defaultProps = defaultProps;
